import React, { ReactNode } from 'react'
import { twMerge } from 'tailwind-merge'

import { Box } from '../box'
import { HStack } from '../hstack'
import { ErrorCircleGlyph } from '../primitive-glyphs/glyphs'
import { Text } from '../text'

export type FieldErrorProps = {
    children: ReactNode
    className?: string
}

export const FieldError: React.FC<FieldErrorProps> = ({ children, className }) => (
    <HStack role='status' className={twMerge('mt-1 items-start gap-1 px-1', className)}>
        <Box className='shrink-0'>
            <ErrorCircleGlyph size={20} />
        </Box>
        <Text size='body' tone='critical' weight='semiBold' className='flex-1'>
            {children}
        </Text>
    </HStack>
)
